module.exports = __webpack_public_path__ + "img/1_012.94969504.jpg";